// In theme.js
import { defaultTheme } from 'react-admin'
import merge from 'lodash/merge'
import { createMuiTheme } from '@material-ui/core/styles'
import createPalette from '@material-ui/core/styles/createPalette'

const palette = createPalette(
  merge({}, defaultTheme.palette, {
    type: 'dark',
    primary: {
      light: '#757ce8',
      main: '#0397C9',
      dark: '#0397C9',
      contrastText: '#fff'
    },
    secondary: {
      light: '#0397C9',
      main: '#0397C9',
      dark: '#0397C9',
      contrastText: '#fff'
    },
    background: {
      default: '#024B6E',
      paper: '#ffffff'
    }
  })
)

const rawTheme = {
  palette,
  typography: {
    fontFamily: '"Manrope", cursive'
  },
  overrides: {
    MuiPaper: {
      elevation1: {
        boxShadow: 'none'
      },
      root: {
        backgroundClip: 'padding-box',
        color: '#000'
      }
    },
    MuiTableCell: {
      body: {
        color: '#000'
      },
      head: {
        color: '#000'
      },
      root: {
        borderBottomColor: '#e0dfdf'
      }
    },
    MuiTableSortLabel: {
      root: {
        color: '#000',
        '&:hover': {
          color: 'rgba(0,0,0,.7)'
        }
      },
      active: {
        color: '#000 !important'
      },
      icon: {
        color: 'grey !important'
      }
    },
    MuiListItemIcon: {
      root: {
        color: '#000',
        ['@media (max-width:600px)']: { // eslint-disable-line no-useless-computed-key
          color: '#fff'
        }
      }
    },
    RaMenuItemLink: {
      icon: {
        color: '#fff'
      }
    },
    RaLogout: {
      menuItem: {
        color: '#000',
        ['@media (max-width:600px)']: { // eslint-disable-line no-useless-computed-key
          color: 'rgba(255, 255, 255, 0.7)'
        }
      }
    },
    RaPaginationActions: {
      actions: {
        color: '#000'
      }
    },
    MuiTablePagination: {
      root: {
        color: '#000'
      },
      select: {
        color: '#000'
      }
    },
    MuiButton: {
      root: {
        color: '#000'
      },
      contained: {
        '&$disabled': {
          color: 'rgba(255, 255, 255, 0.3)',
          backgroundColor: 'rgba(0, 0, 0, 0.25)'
        }
      }
    },
    MuiFormLabel: {
      root: {
        color: 'grey'
      }
    },
    MuiFormHelperText: {
      root: {
        color: '#000'
      }
    },
    MuiInputBase: {
      root: {
        color: 'inherit'
      }
    },
    RaToolbar: {
      toolbar: {
        backgroundColor: '#fff',
        borderTop: '1px solid #e0dfdf'
      }
    },
    MuiTypography: {
      colorTextSecondary: {
        color: 'inherit'
      }
    },
    MuiCheckbox: {
      root: {
        color: 'rgba(0,0,0,.7)'
      }
    },
    MuiDivider: {
      root: {
        backgroundColor: 'rgba(34,42,58,0.2)'
      }
    },
    MuiFilledInput: {
      root: {
        '& svg': {
          fill: '#000000'
        }
      }
    }
  }
}

export const theme = createMuiTheme(
  merge({}, defaultTheme, rawTheme)
)
